<template>
	<div class="margin-left list">
		<div class="flex margin-bottom-sm align-center topall bg-white">
			<p @click="chose(item.id)" class="flex-sub text-center pointer" :class="topindex == item.id?'active text-theme':''" v-for="(item,index) in top" :key="index">{{item.name}}</p>
			
		</div>
		<div v-if="total != 0">
			<el-row :gutter="20">
				<el-col :span="12" v-for="(item,index) in listData" :key="index">
					<MineList :data="item" @godetail="godetail"></MineList>
				</el-col>
			</el-row>
			<div class="pagination">
				<el-pagination
				  background
				  @current-change="handleCurrentChange"
				  layout="prev, pager, next"
				  prev-text="上一页"
				  next-text="下一页"
				  :total="total">
				</el-pagination>
			</div>
		</div>
		<div class="text-center" v-else>
			<el-empty description="暂无数据"></el-empty>
		</div>
	</div>
</template>

<script>
	import Bus from '@/store/eventBus.js'
	import MineList from '../../list/mine-list.vue';
	export default {
		components: {
			MineList,
		},
		data() {
			return {
				top:[
					{
						name:'全部',
						id:2
					},{
						name:'已上架',
						id:1
					},{
						name:'已下架',
						id:0
					}
				],//状态
				topindex:2,//选中的状态下表
				page:1,
				total:0,//
				listData:[],//列表
			};
		},
		created() {
			this.getlist()
		},
		methods: {
			//选择状态
			chose(index){
				this.topindex = index
			},
			//去详情
			godetail(e){
				let type = {
					type:'minedetail',
					typeone:'mine'
				}
				this.$emit('gettype',type)
				console.log(e);
				setTimeout(() => {
				     Bus.$emit('getmindid',e.id)
				   }, 500);
			},
			handleCurrentChange: function(currentPage) {
			  this.page = currentPage;
			  this.getlist();
			},
			/**
			 * 我的课程列表
			 * */
			getlist(){
				this.ajax('get', '/api/course/getMyCourse',{
					page:this.page,
					status:this.topindex
				}, res => {
					console.log(res);
					if(res.status == 200){
						this.listData = res.data.data
						if(this.page == 1){
							this.total =  Number(res.data.lastpage) * Number(res.data.data.length)
						}
					}else{
						this.$message(res.msg);
					}
				})
			}
		}
	}
</script>

<style scoped lang="less">
	.list{
		width: 921px;
	}
	.topall{
		width: 921px;
		height: 69px;
		box-shadow: -4px 3px 19px 1px rgba(204,204,204,0.2000);
		border-radius: 10px;
		p{
			height: 69px;
			line-height: 69px;
		}
	}
	/deep/ .el-pagination.is-background .btn-next,/deep/ .el-pagination.is-background .btn-prev,/deep/ .el-pagination.is-background .el-pager li{
		background: #fff !important;
	}
	/deep/ .el-pagination.is-background .el-pager li:not(.disabled).active{
		background:#09827B !important;
		color: #fff !important;
	}
	/deep/ .el-pagination.is-background .btn-prev,/deep/ .el-pagination.is-background .btn-next{
		padding: 0 10px;
	}
	
	.pagination{
		margin: 59px 0;
	}
	.active{
		
		position: relative;
		&:after{
			position: absolute;
			bottom: 0;
			left: 50%;
			transform: translateX(-50%);
			width: 27px;
			height: 6px;
			background: #0B837C;
			border-radius: 3px;
			content: '';
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/my/course/mine.vue